// Правила инициации по редкости (минимальный ход матча, в котором карта
// активна или розыгрыш Действия даёт эффект).
//
// Этап 21: единое правило для юнитов и Действий, согласовано с диздоком v2.9.
//   - common:    1-й ход (instant в любой ход матча).
//   - rare:      3-й ход.
//   - epic:      4-й ход.
//   - legendary: 5-й ход.
//
// Семантика «отсчёт от начала матча»: проверяем state.currentTurn (номер
// хода матча, начинается с 1) против initiation.
//   - Юнит, разыгранный РАНЬШЕ — стоит спящим (Card.isSleeping=true).
//     Спящий юнит не атакует, его Order ждёт пробуждения (см.
//     runUnitOrdersOnReveal).
//   - Действие, разыгранное РАНЬШЕ — сгорает без эффекта (см. phases.js,
//     resolvePendingActions).
//
// Если в xlsx у карты задано initiation (число) — оно имеет приоритет над
// формулой по rarity (для нестандартных карт). Если initiation null/undefined —
// применяется формула.

export function initiationForRarity(rarity) {
  switch (rarity) {
    case 'legendary': return 5;
    case 'epic':      return 4;
    case 'rare':      return 3;
    case 'common':    return 1;
    default:          return 1;
  }
}

// Резолвинг initiation для шаблона карты. Если template.initiation число —
// возвращаем как есть. Иначе — формула по rarity.
export function resolveInitiation(template) {
  if (!template) return 1;
  if (typeof template.initiation === 'number') return template.initiation;
  return initiationForRarity(template.rarity);
}
